module.exports = __webpack_public_path__ + "static/media/service_tile_bodybuilding.d3579d0b.jpg";